<template>
  <div class="header-container">
    <div
      class="menu01-box"
      v-show="$store.state.isVrNav"
      @mouseout="vrNav()"
      @mouseover="revrNav()"
    >
      <ul class="main header-menu menu01">
        <li>
          <div :class="['header-menu-item', 'line']">
            <router-link
              :class="['menu-item-link', 'menuOneRow']"
              @click.native="toNav('/vr')"
              to="/vr"
              target="_blank"
              >VR</router-link
            >
          </div>
          <div :class="['header-menu-item', 'line']">
            <router-link
              :class="['menu-item-link', 'menuOneRow']"
              @click.native="toNav('/ar')"
              to="/ar"
              target="_blank"
              >AR</router-link
            >
          </div>
          <div :class="['header-menu-item', 'line']">
            <router-link
              :class="['menu-item-link', 'menuOneRow']"
              @click.native="toNav('/vrselect')"
              to="/vrselect"
              target="_blank"
              >线上选型</router-link
            >
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {},
  methods: {
    //移入显示导航栏
    vrNav() {
      this.$store.commit("SET_ISVRNAV", false);
    },
    revrNav() {
      this.$store.commit("SET_ISVRNAV", true);
    },
    //点击顶部导航跳转对应的
    toNav(path) {
      sessionStorage.setItem("navIndex", JSON.stringify(3));
      //this.$store.commit("SET_NAVALLINDEX", 2);
      /*
      var routeUrl = this.$router.resolve({
        path: path,
      });
      window.open(routeUrl.href, "_blank");
      */
    },
  },
};
</script>

<style lang='scss' scoped>
@import "./index.scss";
</style>
